export default __webpack_public_path__ + "static/media/translationIcon.0add3137.svg";